import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { updatePrice } from "./PriceDisplay";
import CreateMissionHeaderAndTitleRow from "./CreateMissionHeaderAndTitleRow";
import CreationFooter from "./CreationFooter";
import { useAlert } from 'react-alert'
import { AudienceRequirementsCard } from "./AudienceRequirements";
import NumberCircle from "../../../../../../../assets/images/researcher_app/create/audience_instruction_background.svg";
import AudienceScreenerCard from "./AudienceScreenerCard";
import UserTypeCard from "./UserTypeCard";
import AudienceOptionsCard from "./AudienceOptionsCard";



// Api Calls



function Audience(props) {
    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [submitInProcess, setSubmitInProcess] = useState(false);

    const [price, setPrice] = useState("-");
    const [totalPrice, setTotalPrice] = useState("-");

    function updatePriceWrapper() {
        updatePrice(setPrice, setTotalPrice, missionId, navigate, alert);
    }

    function onClickBack() {
        navigate(props.backPath, { state: { missionId: missionId } })
    }
    function onClickNext(event) {
        event.preventDefault();
        navigate(props.nextPath, { state: { missionId: missionId } })

    }

    var backPath = props.backPath ? onClickBack : null;

    useEffect(() => {
        updatePriceWrapper();
    }, []);


    return (
        <div className="create-mission-primary-content-container">
            <CreateMissionHeaderAndTitleRow title={"Audience"} subtitle="Who do you want feedback from?" price={price} totalPrice={totalPrice} />
            <div className="session-details-container">
                <div className="instructions-and-reqs-container">
                    <AudienceInstructions />
                    <UserTypeCard updatePrice={updatePriceWrapper} />
                    <AudienceRequirementsCard updatePrice={updatePriceWrapper} />
                    <AudienceScreenerCard />
                    <AudienceOptionsCard updatePrice={updatePriceWrapper} />
                </div>
                <CreationFooter buttonText={props.nextText} onClickBack={backPath} onClickSubmit={onClickNext} submitLoading={submitInProcess} />
            </div>
        </div>

    )
}


function AudienceInstructions(props) {

    return (
        <div className="audience-instructions-container">
            <AudienceInstructionRow number="1" text="Choose which types of users you'd like to target" />
            <AudienceInstructionRow number="2" text="Specify exact audience criteria like country, demographics, and on-chain activity" />
            <AudienceInstructionRow number="3" text="Write screener questions to narrow your audience further" />
        </div>
    )
}

function AudienceInstructionRow(props) {
    return (
        <div className="audience-instruction-row">
            <div className="audience-instruction-number">
                <div className="audience-instruction-number-text">{props.number}</div>
                <img src={NumberCircle} className="audience-instruction-number-bg" />
            </div>
            <div className="audience-instruction-text">{props.text}</div>
        </div>
    )
}

export default Audience;